import React, { useEffect, useState } from 'react';
import { extractNumber } from '@/lib/utils';
import useCopilotValueStore from '@/stores/copilotValueStore';
const PerformanceTable: React.FC = () => {
  const { copilotValue4 } = useCopilotValueStore();
  const [pullbackStatus, setPullbackStatus] = useState(0);
  const [returnStatus, setReturnStatus] = useState(0);
  useEffect(() => {
    const returnRes = extractNumber(copilotValue4?.evaluation?.return_res || '');
    if (Number(returnRes) > Number(extractNumber(copilotValue4?.returnRes || ''))) {
      setReturnStatus(1);
    } else if (Number(returnRes) < Number(extractNumber(copilotValue4?.returnRes || ''))) {
      setReturnStatus(-1);
    } else {
      setReturnStatus(0);
    }

    const pullback = extractNumber(copilotValue4?.evaluation?.pullback || '');
    if (Number(pullback) <= Number(extractNumber(copilotValue4?.pullback || ''))) {
      setPullbackStatus(1);
    } else {
      setPullbackStatus(0);
    }
  }, [copilotValue4]);
  return (
    <div className="rounded-lg bg-white p-3">
      <div className="mb-3 flex items-center gap-2">
        <span className="text-sm font-semibold text-[#1F1F1F]">组合表现验证</span>
      </div>
      <div className="overflow-hidden rounded-md border border-[#F0F0F0]">
        <div className="grid grid-cols-4 border-b border-[#F0F0F0] bg-[#F0F5FF]">
          <div className="border-r border-[#F0F0F0] p-2 text-center text-sm font-semibold text-[#1F1F1F]">
            评估指标
          </div>
          <div className="border-r border-[#F0F0F0] p-2 text-center text-sm font-semibold text-[#1F1F1F]">
            组合表现
          </div>
          <div className="border-r border-[#F0F0F0] p-2 text-center text-sm font-semibold text-[#1F1F1F]">
            客户要求
          </div>
          <div className="p-2 text-center text-sm font-semibold text-[#1F1F1F]">达标状态</div>
        </div>
        <div className="grid grid-cols-4 border-b border-[#F0F0F0]">
          <div
            title="近一年收益率"
            className="truncate whitespace-nowrap border-r border-[#F0F0F0] p-2 text-center text-xs text-[#1F1F1F]"
          >
            近一年收益率
          </div>
          <div className="border-r border-[#F0F0F0] p-2 text-center text-xs text-[#CF1322]">
            {copilotValue4?.evaluation?.return_res}
          </div>
          <div className="border-r border-[#F0F0F0] p-2 text-center text-xs text-[#1F1F1F]">
            ≥ <span>{copilotValue4?.returnRes || '0%'}</span>
          </div>
          <div className="p-2 text-center text-xs text-[#16A34A]">
            {returnStatus === 1 ? '超额达成' : returnStatus === -1 ? '未达预期' : '预期达成'}
          </div>
        </div>
        <div className="grid grid-cols-4">
          <div
            title="近一年最大回撤"
            className="truncate whitespace-nowrap border-r border-[#F0F0F0] p-2 text-center text-xs text-[#1F1F1F]"
          >
            近一年最大回撤
          </div>
          <div className="border-r border-[#F0F0F0] p-2 text-center text-xs text-[#CF1322]">
            {copilotValue4?.evaluation?.pullback}
          </div>
          <div className="border-r border-[#F0F0F0] p-2 text-center text-xs text-[#1F1F1F]">
            ≤ <span>{copilotValue4?.pullback || '0%'}</span>
          </div>
          <div className="p-2 text-center text-xs text-[#16A34A]">
            {pullbackStatus === 1 ? '风险可控' : '风险超出'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceTable;
